import React, { useState, useRef, useEffect } from "react";
import { Update } from "./Update";
import MigrationHistory from "./MigrationHistory";
import MigrationProgressBar from "./MigrationProgressBar";
import ResetMigrationsButton from "./ResetMigrationsButton";
import "./RunUpdate.css";
import AdminNavBar from "./AdminNavBar";

export default function RunUpdate() {
  const [logs, setLogs] = useState([]);
  const [pending, setPending] = useState(false);
  const [progress, setProgress] = useState(0);
  const terminalRef = useRef(null);

  const checkForUpdates = async () => {
    setLogs([]);
    setProgress(10);

    const originalLog = console.log;
    let found = false;

    console.log = (...args) => {
      originalLog(...args);
      const msg = args.join(" ");
      setLogs(prev => [...prev, msg]);

      if (msg.includes("MIGRATIONS_EXIST")) found = true;
    };

    await Update(true);

    console.log = originalLog;

    setPending(found);
    setProgress(found ? 50 : 100);
  };

  const applyUpdates = async () => {
    if (!pending) return;

    setProgress(20);
    setLogs(prev => [...prev, "Applying updates..."]);

    const originalLog = console.log;

    console.log = (...args) => {
      originalLog(...args);
      setLogs(prev => [...prev, args.join(" ")]);
    };

    await Update(false);

    console.log = originalLog;

    setProgress(100);
  };

  useEffect(() => {
    if (terminalRef.current) {
      terminalRef.current.scrollTop = terminalRef.current.scrollHeight;
    }
  }, [logs]);

  return (
    <div className="migration-home">

      <AdminNavBar />

      <div className="migration-dashboard">
        <h1>Migration Dashboard</h1>

        <div className="migration-actions">
          <button onClick={checkForUpdates}>Check for Updates</button>

          {pending && (
            <button onClick={applyUpdates}>Apply Updates</button>
          )}

          <ResetMigrationsButton />
        </div>

        <MigrationProgressBar progress={progress} />

        <div className="migration-terminal" ref={terminalRef}>
          {logs.map((line, i) => (
            <div key={i}>{line}</div>
          ))}
        </div>

        <MigrationHistory />
      </div>
    </div>
  );
}
